<div class="login-page">
    <div class="login-box">
        <div>
            <form (ngSubmit)="resetPassword()">
                <a class="logo-lg" href="">
                    <img src="./assets/images/logo.svg" alt="">
                </a>
                <h1>Reset Password</h1>
                <div class="form-group mb-3">
                    <mat-label for="">New Password <span class="required">*</span></mat-label>
                    <mat-form-field class="">
                        <input matInput [type]="hide() ? 'password' : 'text'" [formControl]="newPassword" [(ngModel)]="resetPasswordModel.newPassword" placeholder="New Password" />
                        <a href="javascript:void(0)" 
                            mat-icon-button
                            matSuffix
                            class="me-2"
                            (click)="clickEvent($event)"
                            [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hide()">
                            <mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </a>
                    </mat-form-field>
                    <div *ngIf="newPassword.touched" class="mat-mdc-form-field-error">
                        <small *ngIf="newPassword.errors?.['required']">New Password is required.</small>
                    </div>
                </div>
                <div class="form-group mb-3">
                    <mat-label for="">Confirm Password <span class="required">*</span></mat-label>
                    <mat-form-field class="">
                        <input matInput [type]="hideConfirm() ? 'password' : 'text'" [formControl]="confirmPassword" [(ngModel)]="resetPasswordModel.confirmPassword" placeholder="Confirm Password" />
                        <a href="javascript:void(0)" 
                            mat-icon-button
                            matSuffix
                            class="me-2"
                            (click)="clickEventConfirm($event)"
                            [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hideConfirm()">
                            <mat-icon>{{hideConfirm() ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </a>
                    </mat-form-field>
                    <div *ngIf="confirmPassword.touched" class="mat-mdc-form-field-error">
                        <small *ngIf="confirmPassword.errors?.['required']">Confirm Password is required.</small>
                    </div>
                </div>
                <button class="mt-2 m-l-10 pull-right me-3" mat-raised-button color="primary"> Submit </button>
                <button class="mt-2 m-l-10 pull-right me-3 btn-black" mat-raised-button color="primary" (click)="cancelAction()"> Cancel </button>
            </form>
        </div>
    </div>
    <div class="copy-right">
        © {{ currentYear }} {{ 'FOOTER_TEXT' | translate }}
    </div>
</div>